import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CursorPosition
*  Данные курсора для запроса предыдущих записей<br>
*/
export class CursorPosition extends ActiveModel {

/**
  * field
  * Значение для соответствующего поля Web.Core.Pagination.SortOptions.CursorField<br>постраничного запроса для затребования следующей страницы<br>
  */
  @ActiveField('')
  field: string = ''


/**
  * id
  * Значение для соответствующего поля Web.Core.Pagination.SortOptions.CursorId<br>постраничного запроса для затребования следующей страницы<br>
  */
  @ActiveField('')
  id: string = ''
}
